const stateSelector = (state) => state.team;

export const selectTeam = (state) => stateSelector(state).items;
